 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"8":"stencil-ion-avatar_3-ios-entry-js","9":"stencil-ion-avatar_3-md-entry-js","10":"stencil-ion-back-button-ios-entry-js","11":"stencil-ion-back-button-md-entry-js","12":"stencil-ion-backdrop-ios-entry-js","13":"stencil-ion-backdrop-md-entry-js","14":"stencil-ion-card_5-ios-entry-js","15":"stencil-ion-card_5-md-entry-js","16":"stencil-ion-checkbox-ios-entry-js","17":"stencil-ion-checkbox-md-entry-js","18":"stencil-ion-chip-ios-entry-js","19":"stencil-ion-chip-md-entry-js","20":"stencil-ion-col_3-entry-js","21":"stencil-ion-fab_3-ios-entry-js","22":"stencil-ion-fab_3-md-entry-js","23":"stencil-ion-img-entry-js","24":"stencil-ion-infinite-scroll_2-ios-entry-js","25":"stencil-ion-infinite-scroll_2-md-entry-js","26":"stencil-ion-input-ios-entry-js","27":"stencil-ion-input-md-entry-js","28":"stencil-ion-loading-ios-entry-js","29":"stencil-ion-loading-md-entry-js","30":"stencil-ion-popover-ios-entry-js","31":"stencil-ion-popover-md-entry-js","32":"stencil-ion-progress-bar-ios-entry-js","33":"stencil-ion-progress-bar-md-entry-js","34":"stencil-ion-radio_2-ios-entry-js","35":"stencil-ion-radio_2-md-entry-js","36":"stencil-ion-reorder_2-ios-entry-js","37":"stencil-ion-reorder_2-md-entry-js","38":"stencil-ion-ripple-effect-entry-js","39":"stencil-ion-spinner-entry-js","40":"stencil-ion-split-pane-ios-entry-js","41":"stencil-ion-split-pane-md-entry-js","42":"stencil-ion-tab-bar_2-ios-entry-js","43":"stencil-ion-tab-bar_2-md-entry-js","44":"stencil-ion-tab_2-entry-js","45":"stencil-ion-text-entry-js","46":"stencil-ion-textarea-ios-entry-js","47":"stencil-ion-textarea-md-entry-js","48":"stencil-ion-toggle-ios-entry-js","49":"stencil-ion-toggle-md-entry-js","50":"stencil-ion-virtual-scroll-entry-js","51":"stencil-polyfills-css-shim"}[chunkId]||chunkId) + "." + {"0":"3b8135f2","1":"5482bac0","2":"54d5e86d","3":"1b663ce3","4":"cae8df4d","5":"6b313392","8":"cebab95d","9":"312f3a94","10":"198b7909","11":"a9fa1f5a","12":"60711f40","13":"d1dcfc28","14":"5ba91b53","15":"a4fd3243","16":"0986b58f","17":"cdb8f5e3","18":"be78117b","19":"68e56fbf","20":"712d771c","21":"f95cc6db","22":"43b3bdd8","23":"b033272d","24":"555b550f","25":"7329d02d","26":"dbb08bef","27":"836ab157","28":"dacbb909","29":"afeec95e","30":"dd20c54d","31":"04af904c","32":"73880a8a","33":"a497882e","34":"aa563988","35":"b6ca60df","36":"dd89ac81","37":"2ae66d2e","38":"32f696bb","39":"fdc92836","40":"e5be804f","41":"c2c0fec2","42":"5587f255","43":"1d6806e9","44":"c40cf4fc","45":"07362c6f","46":"d352f8c3","47":"beeccc66","48":"4faabd32","49":"9323c584","50":"b1b9859c","51":"137a62f6","53":"6855698f","54":"9df14dde","55":"d2bedec4","56":"7766d241","57":"4e6058f7","58":"ecb86bbd","59":"fc20fe24","60":"943f2ecb","61":"06964905","62":"88dfe030","63":"2a4464e8","64":"e9ed1051","65":"0389a113","66":"00d7924f","67":"eece9a60","68":"87f08c41","69":"c4e9d8a3","70":"9392100f","71":"289490de","72":"91cdfbb4","73":"767f2418","74":"2aa95d0d","75":"6ad76fa9","76":"b06913f5","77":"814f24cb","78":"838ed514","79":"0cad272a","80":"781931a5","81":"d65a5020","82":"7d64e356","83":"343d3aba","84":"73383412","85":"1aeadb63","86":"86ba1ba4","87":"50fd0f2f","88":"0c98216c","89":"96f99170","90":"f1b801e4"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "./";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpbitswebsite"] = this["webpackJsonpbitswebsite"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
